import React from 'react';
import '../../../resources/AdminStandardPage.css';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import DeleteDialog from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import {
  addCustomArchiveYear,
  getArchiveYears,
  removeCustomArchiveYear
} from '../../../services/ArchiveYearsService';

class ArchiveYears extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      year: '',
      archiveYears: getArchiveYears(),
      deleteArchiveYear: {
        openedDialog: false,
        yearValue: ''
      }
    };
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  updateField = event => {
    this.setState({ year: event.target.value });
  };

  resetForm = () => {
    this.setState({ year: '' });
  };

  refreshArchiveYears = () => {
    this.setState({
      archiveYears: getArchiveYears()
    });
  };

  handleFormSubmit = event => {
    event.preventDefault();

    const result = addCustomArchiveYear(this.state.year);

    if (!result.success) {
      this._notificationSystem.addNotification({
        message:
          result.reason === 'exists'
            ? 'Anul există deja în arhivă.'
            : 'Introdu un an valid (format YYYY).',
        level: 'warning',
        position: 'tc'
      });
      return;
    }

    this.refreshArchiveYears();
    this.resetForm();

    this._notificationSystem.addNotification({
      message: 'Anul a fost adaugat cu succes.',
      level: 'success',
      position: 'tc'
    });
  };

  openDeleteDialog = yearValue => {
    this.setState({
      deleteArchiveYear: {
        openedDialog: true,
        yearValue
      }
    });
  };

  closeDeleteDialog = () => {
    this.setState({
      deleteArchiveYear: {
        openedDialog: false,
        yearValue: ''
      }
    });
  };

  handleDelete = () => {
    const result = removeCustomArchiveYear(this.state.deleteArchiveYear.yearValue);

    this.closeDeleteDialog();

    if (!result.success) {
      this._notificationSystem.addNotification({
      message: 'Anul implicit din aplicatie nu poate fi sters.',
        level: 'warning',
        position: 'tc'
      });
      return;
    }

    this.refreshArchiveYears();
    this._notificationSystem.addNotification({
      message: 'Anul a fost sters cu succes.',
      level: 'success',
      position: 'tc'
    });
  };

  canDeleteYear = year => year.name !== 'Arhiva';

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h1 className="admin-switch-title default-title">Ani arhiva</h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adauga un an in arhiva:</h2>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">An *</h4>
                  <input
                    required
                    min="1900"
                    max="2999"
                    step="1"
                    className="general-field title-field"
                    type="number"
                    name="year"
                    onChange={this.updateField}
                    value={this.state.year}
                  />
                </div>

                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button type="submit" className="submit-button general-button">
                      Adauga an
                    </button>
                  </div>
                  <button
                    type="button"
                    className="general-button reset-button"
                    onClick={this.resetForm}
                  >
                    Reseteaza campurile
                  </button>
                </div>
              </form>
            </div>
          </div>

          {this.state.archiveYears.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">Ani existenți</h2>
                  <div className="existing-items__content">
                    {this.state.archiveYears.map(archiveYear => (
                      <div
                        className="existing-items__content-card"
                        key={archiveYear.value}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">{archiveYear.name}</h3>
                        </div>
                        <div className="existing-items__actions-card">
                          {this.canDeleteYear(archiveYear) ? (
                            <div
                              className="provisions-title-content"
                              onClick={() =>
                                this.openDeleteDialog(archiveYear.value)
                              }
                            >
                              <h4 className="action-title delete-button">Șterge</h4>
                            </div>
                          ) : (
                            <div className="provisions-title-content">
                              <h4 className="action-title">Implicit</h4>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <DeleteDialog
                  opened={this.state.deleteArchiveYear.openedDialog}
                  handleClose={this.closeDeleteDialog}
                  handleDelete={this.handleDelete}
                  headline="Sunteti sigur ca doriti sa stergeti acest an?"
                  aditionalText="Actiunea nu poate fi anulata."
                />
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default ArchiveYears;
